import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import moment from 'moment';
import { Tooltip as AntdTooltip } from 'antd';
import {  Table, Select, DatePicker, Spin, Input, Tag, Skeleton } from 'antd';
import { ArrowRightOutlined, CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar} from 'recharts';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;
const { TextArea } = Input;

const Customers = () => {

  var today = new Date();
  var local_month = JSON.parse(localStorage.getItem('month'));
  if(local_month){
   var mm = local_month
  }else{
      var mm = String(today.getMonth() + 1).padStart(2, '0')
  }

  var yyyy = today.getFullYear()
  yyyy = yyyy.toString()

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [month, setMonth] = useState(mm)
  const [year, setYear] = useState(yyyy)
  const [gameType, setGameType] = useState(local_game_type)
  const [customerData, setCustomerData] = useState([])
  const [graphData, setGraphData] = useState({})
  const [chartData, setChartData] = useState({})
  const [maxVal, setMaxVal] = useState('')
  const [graphLoading, setGraphLoading] = useState(true)
  const [graphLoader, setGraphLoader] = useState(true)

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
  }, [month,year,selectedVenueId,cityId,gameType]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getCustomerDetails()
      getRevenueGraph()
    }
  }, [month,year,selectedVenueId,cityId,gameType]); 

  useEffect(() =>{
    if(cities.length > 0 && cityId.length > 0){
      getCustomerGraph()
    }
  }, [cities,selectedVenueId,cityId,gameType])

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const getCustomerDetails = () => {
    getData(`/business/get_customers_overview/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)
    .then(response =>{
      setCustomerData(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }


  const getCustomerGraph = () => {
    var venue = ''
    if(selectedVenueId == 'All'){
      if(cityId){
        var venue = cityId
        if(cityId.length > 1){
          const venue_in_city = venues.filter(item => cityId.includes(item.city));
          const locationIds = venue_in_city.map(v => v.location);
          var venue = locationIds.join(',');
        }
      }
    }
    else{
      var venue = selectedVenueId
    }

    if(venue == 'All'){
      var venue = 0
    }
    setGraphLoader(true)
    getData(`/eagleeye/getTableDataJSON/?report_id=76371&venue_id=${venue}&game_type_id=${gameType}`)
    .then(response =>{
      setChartData(response.data)
      setGraphLoader(false)
      calculateYaxis(response.data)      
    })
    .catch(error => {
      setGraphLoader(false)
      console.log(error.message);
    });
  }

  const getRevenueGraph = () => {
    setGraphLoading(true)
    getData(`/business/get_dashboard_graph/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)    
    .then(response =>{
      setGraphData(response.result)
      setGraphLoading(false)
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const calculateYaxis = (data) => {
    if(data && data.length > 0){
      const maxVal = Math.max(
        ...data.map(item => Math.max(item.new_customers))
      );
      setMaxVal(Math.ceil(maxVal / 10) * 10);

      const reversedData = data.reverse();
      setChartData(reversedData)
      setGraphLoader(false)
    }
    else{
      setGraphLoader(false)
      setChartData([])
    }
  };

  const replaceCharacter = (value) => {
    if(Math.sign(value) == '-1'){
      return value.toString().replace('-','')
    }
    else{
      return value
    }
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const renderHeader = (title,type) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: type ? 'normal' :'bold' }}>{title}</div>
    )
  }  

  const customerLevels = ['regular', 'advanced','elite', 'residential'];

  const levelNames = customerLevels.filter(level =>
    customerData.some(venue => venue[level] > 0)
  );

  const academyColumn = {
    title: renderHeader('Academy'),
    align: 'center',
    children: [
      ...levelNames.map(level => { 
        const capitalizedLevel = level?.charAt(0).toUpperCase() + level?.slice(1) || ''
        return({
        title: renderHeader(capitalizedLevel, 'normal'),
        width: 120,
        dataIndex: level,
        align: 'center',
        render: (count, record) => {
          return count;
        },
      })})
    ],
  };

  const columns = customerData.length > 0 ? 
    [
      ...Object.keys(customerData[0]).filter(key => key !== 'venue_id' && key !== 'percent_diff' && key !== 'difference' && key !== 'is_active'
          && key !== 'elite' && key !== 'residential' && key !== 'regular' && key !== 'advanced'
        ).map(key => ({
        title: renderHeader(key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')),  
        dataIndex: key,
        key: key,
        width: key === 'venue' ? 450 : 150,
        align: key !== 'venue' && 'center',
        render: key === 'venue' ? 
                  (text, record) => {
                    const venuename = record.venue.length > 25 ? `${record.venue.slice(0, 25)}...` : record.venue;
                    return(
                      <div className="venueTitle" style={{ display: 'flex', alignItems: 'center', gap: 8}}>
                        <AntdTooltip title={record.venue}>
                        <Link className="venueTitle" to={`/customers/${record.venue_id}`}>
                          {record.venue}
                        </Link>
                        </AntdTooltip>
                        {!record.is_active && (
                          <Tag color="red" style={{ margin: 0 }}>
                            Inactive
                          </Tag>
                        )}
                      </div>
                    )
                  }
                : key === 'customers' ? 
                  (text, record) => (
                    <div style={{display:'grid',gridTemplateColumns: '1fr auto'}}>                    
                      <Link to={`/customerList/?venue_id=${record.venue_id}`} className='venueTitle'>{text}</Link>                      
                      {
                        (record.percent_diff || record.percent_diff == 0) ?
                          <AntdTooltip
                            placement="right"
                            title={
                              record.difference > 0
                                ? `Increased by ${record.difference} customers`
                                : record.difference < 0
                                ? `Decreased by ${Math.abs(record.difference)} customers`
                                : 'No change in customer count'
                            }
                          >
                            <Styled.PercentDiv style={{backgroundColor: Math.sign(record.percent_diff) == '1' ? 'rgb(233 255 232)' : 'rgb(255 232 232)'}}>
                              {
                                Math.sign(record.percent_diff) == '1' ?
                                  <CaretUpOutlined  style={{color:  'green'}}/> 
                                :
                                  <CaretDownOutlined  style={{color: 'red'}}/>
                              }
                                <div style={{color: Math.sign(record.percent_diff) === 1 ? 'green' : 'red',fontSize: 'small'}}>
                                  {replaceCharacter(record.percent_diff) + '%'}
                                </div>
                            </Styled.PercentDiv>
                          </AntdTooltip>
                        :
                        <Styled.PercentDiv style={{backgroundColor: 'transparent'}}></Styled.PercentDiv>
                      }                      
                    </div>
                  )
                : key === 'renewed' || key === 'new' || key === 'expired' ?
                  (text, record) => (
                    <Link to={`/customerList/?venue_id=${record.venue_id}&type=${key}`} className='venueTitle'>
                      {text}
                    </Link>
                  )
                : 
                text => text
        })),
      academyColumn,
      {
        title: '',
        dataIndex: 'venue_id',
        width: 10,
        render: (value) => {
          return(
            <Link to={`/customers/${value}`} className='venueTitle'>
              <ArrowRightOutlined/>
            </Link>
            )
        }
      },
    ]
  : 
    [];

  const formatXAxis = (value) => {
    return moment(value).format('MMM')
  };

  return (
      <Styled.MainContainer>

        <Styled.TopDiv>    
          <Styled.SelectorContainer>

            {cities.length > 1 &&         
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }
            {venuelist && venuelist.length > 0 &&
              <Styled.Selector>
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

            <Styled.Selector>
              <span className='indicatorText'>Program</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameType}
                  value = {gameType}
                  bordered={false}
                >
                  <Option value="8"> Football Academy </Option>
                  <Option value="10"> Badminton Academy </Option>
                  <Option value="65"> Swimming Academy </Option>
                  <Option value="44"> Tennis Academy </Option>
                </Select>
            </Styled.Selector>
          </Styled.SelectorContainer>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
              <span className='indicatorText'>Month</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Year</span>
              <div className = 'mainSelector' style={{width: 100}}>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div>
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.Header>          
          <span> Customers Overview</span>
        </Styled.Header>
      
      <Styled.GraphContainer>

        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Active Customers</Styled.LabelHeading>

            <Styled.GraphMonthSelector>
              Last 12 months
            </Styled.GraphMonthSelector>
          
          </Styled.GraphDivLabelDiv>

          {graphLoading ?
            <div style={{ height: '28vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <ResponsiveContainer width="100%" height="80%">
              <LineChart
                width={400}
                height={400}
                data={graphData}
                margin={{top: 5,right: 10,left: 5,bottom: 5}}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="month"
                  tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="active customers" stroke="#02475c" name="Customers" />
                <Line type="monotone" dataKey="regular" stroke="#c48e1a" name="Regular" />
                <Line type="monotone" dataKey="advanced" stroke="#5676f5" name="Advanced" />
                <Line type="monotone" dataKey="elite" stroke="#C495E8" name="Elite" />
                <Line type="monotone" dataKey="residential" stroke="#4345ab" name="Residential" />
              </LineChart>
            </ResponsiveContainer>
          }

          <span></span>
        </Styled.GraphDiv>
        
        <span></span>
        
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> New Additions </Styled.LabelHeading>
          </Styled.GraphDivLabelDiv>

        {graphLoader ?
          <div style={{ height: '28vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
            <Spin />
          </div>
        :
          <ResponsiveContainer width="100%" height="80%">
            <BarChart
              width={400}
              height={400}
              data={chartData}
              margin={{top: 5,right: 10,left: 5,bottom: 5}}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tickFormatter={formatXAxis}/>
              <YAxis domain={[0, maxVal]} />
              <Tooltip />
              <Legend />
              <Bar type="monotone" dataKey="new_customers" fill="#1565C0" name="New Additions"  />
            </BarChart>
          </ResponsiveContainer>
        }

        <span></span>
        </Styled.GraphDiv>

      </Styled.GraphContainer>

      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
        <Table
          className="revenue-table table_container"
          rowKey="id"
          columns={columns}
          dataSource={customerData}
          pagination={{ pageSize: 20, showSizeChanger: false}}
          summary={() => {
            const totalRow = {};
            const excludeKeys = ['venue', 'venue_id', 'is_active', 'percent_diff', 'difference'];
            const totalCount = customerData.length;
            
            if (totalCount > 0) {
              Object.keys(customerData[0]).forEach((key) => {
                if (!excludeKeys.includes(key)) {
                  const isNumber = typeof customerData[0][key] === 'number';
                  if (isNumber) {
                    const total = customerData.reduce((sum, item) => {
                      return sum + (item[key] || 0); 
                    }, 0);
                    totalRow[key] = total;                        
                  }
                }
              });
            }

            const getAllColumns = (cols) => {
              let allCols = [];
              cols.forEach(col => {
                if (col.children && Array.isArray(col.children)) {
                  allCols = [...allCols, ...col.children];
                } else if (col.dataIndex) {
                  allCols.push(col);
                }
              });
              return allCols;
            };

            const allColumns = getAllColumns(columns);

            return (
              <Table.Summary.Row>
                {allColumns.map((col, index) => {
                  const key = col.dataIndex;
                  
                  if (index === 0) {
                    return (
                      <Table.Summary.Cell key={key} align="left">
                        <b>Total</b>
                      </Table.Summary.Cell>
                    );
                  }
                  
                  if (key === 'venue_id') {
                    return <Table.Summary.Cell key={key} />;
                  }
                  
                  const hasTotal = totalRow.hasOwnProperty(key);
                  const totalValue = totalRow[key];
                  
                  return (
                    <Table.Summary.Cell key={key} align="center">
                      {hasTotal && totalValue && <b>{totalValue}</b>}
                    </Table.Summary.Cell>
                  );
                })}
              </Table.Summary.Row>
            );
          }}
        />
      }

      </Styled.MainContainer>
  );
}

export default Customers;